import styled, { css } from "styled-components";
import { theme } from "../../styles/theme";

const variantStyles = {
  primary: css`
    background-color: ${theme.colors.accent.primary};
    color: ${theme.colors.background.canvas};
    border-color: ${theme.colors.accent.primary};

    &:hover:not(:disabled) {
      background-color: ${theme.colors.accent.secondary};
      border-color: ${theme.colors.accent.secondary};
    }
  `,
  secondary: css`
    background-color: ${theme.colors.background.secondary};
    color: ${theme.colors.text.primary};
    border-color: ${theme.colors.stroke.strong};

    &:hover:not(:disabled) {
      background-color: ${theme.colors.background.tertiary};
      border-color: ${theme.colors.accent.primary};
    }
  `,
  ghost: css`
    background-color: transparent;
    color: ${theme.colors.text.secondary};
    border-color: transparent;

    &:hover:not(:disabled) {
      color: ${theme.colors.text.primary};
      background-color: ${theme.colors.background.tertiary};
    }
  `,
  danger: css`
    background-color: ${theme.colors.accent.danger};
    color: ${theme.colors.background.canvas};
    border-color: ${theme.colors.accent.danger};

    &:hover:not(:disabled) {
      background-color: #dc2626;
    }
  `,
  success: css`
    background-color: ${theme.colors.accent.success};
    color: ${theme.colors.background.canvas};
    border-color: ${theme.colors.accent.success};

    &:hover:not(:disabled) {
      background-color: #16a34a;
    }
  `,
};

const sizeStyles = {
  small: css`
    padding: ${theme.spacing.xs} ${theme.spacing.md};
    font-size: ${theme.typography.fontSize.xs};
  `,
  large: css`
    padding: ${theme.spacing.lg} ${theme.spacing["2xl"]};
    font-size: ${theme.typography.fontSize.lg};
  `,
};

export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.xs};
  padding: ${theme.spacing.md} ${theme.spacing.lg};
  border-radius: ${theme.borderRadius.md};
  font-size: ${theme.typography.fontSize.sm};
  font-weight: ${theme.typography.fontWeight.medium};
  border: 1px solid transparent;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  transition:
    background-color ${theme.transitions.fast},
    border-color ${theme.transitions.fast},
    color ${theme.transitions.fast};

  ${({ variant = "primary" }) => variantStyles[variant] || variantStyles.primary};
  ${({ size }) => size && sizeStyles[size]};
  ${({ fullWidth }) => fullWidth && css`width: 100%;`};

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &:active:not(:disabled) {
    opacity: 0.8;
  }
`;

export const IconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: ${theme.borderRadius.pill};
  border: 1px solid ${theme.colors.stroke.subtle};
  background-color: ${theme.colors.background.quaternary};
  color: ${theme.colors.text.primary};
  transition: background-color ${theme.transitions.fast};

  &:hover:not(:disabled) {
    background-color: ${theme.colors.background.muted};
  }

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
`;


